import { z } from "zod";

export const CrudScriptTagsResponseBodySchema = z.object({
  scriptTagEnabled: z.boolean(),
  scriptTagSrc: z.string().nullish(),
});

export type CrudScriptTagsRequestBodyType = z.infer<
  typeof CrudScriptTagsResponseBodySchema
>;
